import { ApiService } from "./apiService";

export const EmailService = ()=> {
    return{
        sendForm:(datas: any)=>{
           return ApiService.post('https://api.emailjs.com/api/v1.0/email/send',datas)
        }
    }
}